<template>
  <div class="l_basic_setting_faq" :class="{ lock: this.alert }">
    <div class="container">
      <div class="title">「香の川製麺スタンプラリー」とは</div>
      <hr />
      <div class="honbun">
        「香の川製麺スタンプラリー」はキャンペーン期間中に新しい店舗に来店するたびに「ラリースタンプ」が獲得できます。<br /><br />
        ※ラリースタンプは香の川製麺スタンプラリーのページに表示されます。<br />
        <font color="red">※来店スタンプ獲得と同じタイミングでラリースタンプも獲得</font>できます。<br />
        <font color="red">※ラリースタンプは1日上限２つ</font>まで獲得が可能です。（2つ目のラリースタンプは、1つ目のラリースタンプ獲得から6時間を経過した来店で獲得可能です）<br />
        ※キャンペーンが切り変わると、以前来店した店舗でも「新しい店舗」としてラリースタンプを獲得できます。
      </div>
      <br /><br />
      <div class="title">ラリースタンプを集めてクーポンをGET！</div>
      <hr />
      <div class="picture"><img src="@/assets/img/seal/faqseal_pic1.png" alt="" /></div>
      <br />
      <div class="honbun">
        ラリースタンプを目標個数まで集めると、クーポンがGETできます。<br /><br />
        ※目標個数はキャンペーンによって異なります。<br />
        ※クーポンの獲得は各キャンペーンにつき1回です。<br />
        ※クーポン獲得後もキャンペーン期間中はラリースタンプを集めることが可能です。<br />
        ※獲得したクーポンは、「クーポン」ページからご確認いただけます。
      </div>
      <br />
      <div>
        <UIButton :label="'香の川製麺スタンプラリーへ'" @click="goSeal" />
      </div>
      <br /><br />
      <div class="title">都府県ごとに違うデザイン！</div>
      <hr />
      <div class="picture"><img src="@/assets/img/seal/faqseal_pic2.png" alt="" /></div>
      <br />
      <div class="honbun">
        ラリースタンプのデザインは各都府県によって異なります。<br />
        香の川製麺が出店している37都府県分に加え、各県内に「特別店舗」が設定されています。<br />
        特別店舗では通常とは少し異なる限定ラリースタンプが獲得できるので、ぜひ探してみてね！<br />
        <br />
        ※ラリースタンプに表示される店舗名はラリースタンプ上での表示用に短縮名称で記載されている場合があります。
      </div>
      <br /><br />
      <div class="title">集めたラリースタンプは「都府県別コレクションページ」で確認！！</div>
      <hr />
      <div class="picture"><img src="@/assets/img/seal/faqseal_pic3.png" alt="" /></div>
      <br />
      <div class="honbun">「都府県別コレクション」のタブでは獲得したラリースタンプを各都府県毎に一覧で確認することができます。
        <br /><br />
        ※同じ店舗で複数回ラリースタンプを獲得されている場合、初回獲得日の日付が記載されます。<br />
        ※ラリースタンプ獲得後に店舗が閉店した場合も履歴に表示されます。<br />
        ※県名横の店舗数の分母は、現時点での店舗数となります。
      </div>
      <br />
      <div>
        <UIButton :label="'香の川製麺スタンプラリーへ'" @click="goSeal" />
      </div>
    </div>
    <VersionCheck :show="alert" :on-close="closeAlert" :msg="errorMsg" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { FactoryTrack } from '../constant/firebase.js'
import VersionCheck from './FAQWalkVersionCheck'
import UIButton from '@/components/UIButton.vue'

export default {
  name: 'FAQSeal',
  components: {
    UIButton,
    VersionCheck
  },
  data: function () {
    return {
      alert: 0,
      errorMsg:
      'このボタンはアプリバージョン6.1.0以上対応です。<br />最新版のアプリにアップデートしてください。'
    }
  },
  created() {
    document.title = '香の川製麺スタンプラリー'
  },
  methods: {
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Native', [
      'actionVer6_1'
    ]),
    goSeal: async function () {
      this.trackEvent(FactoryTrack.createSealCollection())
      this.alert = await this.actionVer6_1()
      if (this.alert === 0) {
        //this.$router.push('/seal')
        this.$router.push({
          name: 'Seal',
          params: { showItem: '開催中のキャンペーン' }
        })
      }
      return false
    },
    closeAlert: function() {
      this.trackEvent(FactoryTrack.createVersionCheckClose())
      this.alert = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.l_basic_setting_faq {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;
  overflow: scroll;

  &.lock {
    overflow: hidden;
  }

  .container {
    padding: 25px;
  }

  .head {
    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  .title {
    color: #66160E;
    font-weight: bold;
    font-size: 16px;
    display: block;
    margin: 0 auto;
    text-align: left;
  }

  .honbun {
    color: #707070;
    position: relative;
    font-size: 4vw;
    display: block;
    margin: 0 auto;
    line-height: 1.5;
    text-align: left;
  }

  .picture {
    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  .btn {
    position: relative;
    padding: 4vw;
  }

  .btn img{
    width: 100%;
    height: auto;
    display: block;
  }

  hr {
    margin-top: 10px;
    margin-bottom: 20px;
    border: none;
    border-bottom: 1px solid #efb90f;
    padding: 0 25px;
  }
}
</style>
